import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

let apiCollection = Vue.axios.create({
  method: 'GET',
  baseURL: '/'
})

let apiResource = Vue.axios.create({
  method: 'POST',
  baseURL: '/',
  headers:{
    'content-Type':'multipart/form-data'
  }
})

// let apiResourcePOST = Vue.axios.create({
//   method: 'POST',
//   baseURL: ''
// })

const axiosArr = [apiCollection, apiResource];
axiosArr.forEach(itemAxios => {
  itemAxios.defaults.withCredentials = true;
  itemAxios.defaults.headers['Requested-with'] = 'restful';
  itemAxios.interceptors.response.use((response) => {
    return response;
  }, (error) => {
    return Promise.reject(error.response);
  });
})


export default {
  queryByCatalog: (opts) => {
    return apiCollection({ url: 'service/rest/dm.DataService/CMS.Information@queryByCatalog/invoke', params: { ...opts } })
  },
  getDetail: (opts) => {
    return apiCollection({ url: 'service/rest/dm.DataService/CMS.Information@compose/invoke', params: { ...opts } })
  },
  getCarouseList : (opts) => {
    return apiCollection({ url: 'cms/index_data', params: { ...opts } })
  },
  applicationCreate : (opts) => {
    return apiResource({ url: 'cim/rights-protection-create', data: { ...opts } })
  },
  complaintCreate : (opts) => {
    return apiResource({ url: 'cim/complaint-create', data: { ...opts } })
  },
  getCatalogInfo: (opts) => {
    return apiCollection({ url: 'cms/getCatalogInfo', params: { ...opts } })
  },
  getProvinceList: (opts) => {
    return apiCollection({ url: 'cim/getProvinceList', params: { ...opts } })
  },
  getOrgContactList: (opts) => {
    return apiCollection({ url: 'cim/getOrgContactList', params: { ...opts } })
  },
  queryCIMInfo: (opts) => {
    return apiCollection({ url: 'cim/queryCIMInfo', params: { ...opts } })
  },
  queryInfo: (opts) => {
    return apiCollection({ url: 'cms/queryInfo', params: { ...opts } })
  },
  getConfig: (key) => {
    return apiCollection({ url: 'service/rest/tk.Config/' + key + '/retrieve'})
  },
  formatDate(value){
    const date = new Date(value);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  },
}
